@if (icons().length) {
  <div>
    @for (icon of icons(); track icon) {
      <span class="icon"
            [appTitle]="icon"
            [ref]="rootControlState()">{{ icon.label || icon.thumbnail }}</span>
    }
  </div>
}
@for (plugin of forms(); track plugin) {
  @if (hasForm(plugin)) {
    <app-form-gen [plugins]="plugins()"
                  [plugin]="plugin"
                  [pending]="pending"
                  [values]="values()"
                  (pendingUsed)="usePending($event)"
                  (togglePlugin)="togglePlugin.emit($event)"
                  (setPlugin)="pending[$event.tag] = $event.value"
                  [children]="admin.getPluginSubForms(plugin.tag)" />
  }
}
@if (empty()) {
  <div class="empty-plugins">
    no plugins
  </div>
}
